/** A class for holding data entries */
export default class DataRegistry {
  registry = {};
  registryKeys = [];

  /** Add one or more entries to the registry. */
  registerData(entryOrEntries) {
    const entries = Array.isArray(entryOrEntries) ? entryOrEntries : [entryOrEntries];
    entries.forEach(currEntry => {
      this.registry[currEntry.key] = currEntry;
      this.registryKeys = Object.keys(this.registry);
    });
  }

  /** Remove one or more entries to the registry. */
  unregisterData(keyOrKeys) {
    const keys = Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys];
    keys.forEach(currKey => {
      delete this.registry[currKey];
      this.registryKeys = Object.keys(this.registry);
    });
  }

  /** Returns all data registry entries. This value is not constant between calls. */
  entries() {
    return Object.values(this.registry);
  }

  /** Returns a specific entity from the registry, if it exists. */
  get(key) {
    return this.registry[key];
  }

  /**
   * Returns the current registry keys.
   * This value is constant between calls if the keys themselves have not changed.
   */
  keys() {
    return this.registryKeys;
  }
}